import { handleActions } from 'redux-actions'
import { hideModal, showModal, updateModal } from './actions'

export const initialState = {
    modalStack: [],
    modalProps: {},
    isOpen: false,
}

export default handleActions(
    {
        [showModal]: (state, { payload }) => {
            const modalStack = state.modalStack.includes(payload.modalType) ? state.modalStack : [...state.modalStack, payload.modalType]

            return {
                ...state,
                modalStack,
                modalProps: {
                    ...state.modalProps,
                    [payload.modalType]: {
                        ...state.modalProps[payload.modalType],
                        ...payload.modalProps,
                    },
                },
                isOpen: true,
            }
        },
        [updateModal]: (state, { payload }) => ({
            ...state,
            modalProps: {
                ...state.modalProps,
                [payload.modalType]: {
                    ...state.modalProps[payload.modalType],
                    ...payload.modalProps,
                },
            },
        }),
        [hideModal]: (state, { payload }) => {
            const modalProps = { ...state.modalProps }
            delete modalProps[payload.modalType]

            const modalStack = state.modalStack.filter((type) => type !== payload.modalType)
            const hasModals = modalStack.length > 0

            return {
                ...state,
                modalStack,
                modalProps,
                isOpen: hasModals,
            }
        },
    },
    initialState
)
